/**
 * Modules - Core functionality modules
 *
 * Structure matches mobile's module-core/src/modules/
 */

// Setup - Integration with main app
export { setupCoreIntegration } from './setup';
export type { AppAuthBridge } from './setup';

// API - Apollo Client and GraphQL
export * from './api';

// Auth - Authentication state management
export * from './auth';

// Config - Application configuration
export * from './config';

// Storage - Web storage (localStorage/IndexedDB)
export * from './storage';

// Stores - Legend-State store setup
export * from './stores';

// Sentry - Error logging
export * from './sentry';

// Commons - Common utilities
export * from './commons';

// Device
export * from './device';

// Directories - Region constants and types
export * from './directories';

// Contracts - Store code emitter and event system
export * from './contracts';
